module.exports = __webpack_public_path__ + "img/car-steering-wheel.c04d805c.svg";